import { styled } from "@mui/material/styles";
import { FormInputText } from "./FormInputs";

export const TextLabeledSegments = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;

  margin: 10px -10px -10px 0;

  max-width: 100%;

  &:first-child {
    margin-top: 0;
  }
`;

export const TextLabeledSegmentsSpace = ({
  children,
}: React.PropsWithChildren<Record<string, unknown>>) => (
  <TextLabeledSegment style={{ flexGrow: 0 }}>
    <TextLabeledSegmentSpaceValue>{children}</TextLabeledSegmentSpaceValue>
  </TextLabeledSegment>
);

interface TextLabeledSegmentsInputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string;
  $inputAs?: React.ComponentProps<typeof TextLabeledSegmentInput>["as"];
  inputRef?: React.Ref<HTMLInputElement>;
  wrapperClassName?: string;
}

export const TextLabeledSegmentsInput = ({
  label,
  name,
  style,
  $inputAs,
  inputRef,
  wrapperClassName,
  ...propsToInput
}: TextLabeledSegmentsInputProps) => (
  <TextLabeledSegmentInputWrapper
    as="label"
    className={wrapperClassName}
    style={style}
  >
    <TextLabeledSegmentInput ref={inputRef} as={$inputAs} name={name} {...propsToInput} />
    <TextLabeledSegmentLabel className="label">{label}</TextLabeledSegmentLabel>
  </TextLabeledSegmentInputWrapper>
);

export const TextLabeledSegment = styled("div")`
  margin-right: 10px;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (max-width: 450px) {
    flex-grow: 1;
  }
`;

const TextLabeledSegmentInputWrapper = styled(TextLabeledSegment)`
  flex-grow: 1;
  max-width: 31.25rem;
`;

const TextLabeledSegmentValue = styled("div")`
  padding-right: 1rem;

  font-size: 1.1rem;
`;

const TextLabeledSegmentSpaceValue = styled(TextLabeledSegmentValue)`
  padding-right: 0;
  color: ${({ theme }) => theme.palette.dream.grayMedium};
`;

export const TextLabeledSegmentInput = styled(FormInputText)`
  border: none;
  border-radius: 0;
  padding: 0;

  &&&:focus {
    box-shadow: none;
  }

  &&&:disabled {
    background: none;
  }

  & + .label {
    transition: 100ms linear all;
  }

  &:hover + .label {
    border-top-color: ${({ theme }) => theme.palette.primary.main};
  }

  &:focus + .label {
    border-top-color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 700;
  }

  &.-hasError + .label {
    border-top-color: ${({ theme }) => theme.palette.error.main} !important;
    color: ${({ theme }) => theme.palette.error.main} !important;
  }
`;

export const TextLabeledSegmentLabel = styled("div")`
  margin-top: 3px;
  padding: 6px 1rem 0 0;
  border-top: 1px solid ${({ theme }) => theme.palette.dream.grayMedium};

  text-transform: uppercase;
  font-size: 0.8rem;
  line-height: 1;
  color: ${({ theme }) => theme.palette.primary.main};
`;
